import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

export const i18n = i18next
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languagedetector
  .use(LanguageDetector)

// init i18next
// for all options read: https://www.i18next.com/overview/configuration-options
i18n.init({
  fallbackLng: 'en',
  lng: 'en',
  debug: (window.env ?? 'dev') === 'dev',
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  react: {
    useSuspense: true, // Enable Suspense for lazy loading
  },
})

// Lazy load translations
;(async () => {
  const [{ default: en }, { convertLanguageJsonToObject }] = await Promise.all([
    import('./en/translation.json'),
    import('./translations'),
  ])

  // Create the 'translations' object to provide full intellisense support for the static json files.
  convertLanguageJsonToObject(en)

  // Add translations to i18n instance
  i18n.addResourceBundle('en', 'translation', en)
})()

export const translationsJson = {
  en: {
    translation: {} as any, // Will be loaded asynchronously
  },
}
